import Trans from "features/translation/components/Trans";
import Button from "components/ui/Button/Button";
import { useDialog } from "context/DialogContext";
import LoginDialog from "features/authentication/components/LoginDialog";
import Dialog from "components/ui/Dialog/Dialog";
import { useHistory } from "react-router-dom";

const LoginExplain = () => {
  const { showDialog, hideDialog } = useDialog();
  const history = useHistory();

  const handleLoginLink = () => {
    showDialog(<LoginDialog/>);
  }

  const handleInfoLink = () => {
    history.push('/handleiding');
    hideDialog();
  }

  return (
    <Dialog title={ `Uitleg` }>
      <>
        <div className={ 'dialog__intro' }>
          <Trans
            text={ 'Om van deze functionaliteiten gebruik te kunnen maken dient u als lid van ANBO-PCOB in te loggen met uw e-mailadres en wachtwoord. Nog geen lid van ANBO-PCOB? Bekijk de voordelen en word ook lid!' }/>
        </div>

        <div className={ 'dialog__buttons' }>
          <Button onClick={ handleLoginLink } variant={ 'secondary' }>Inloggen</Button>
          <Button onClick={ handleInfoLink } variant={ 'primary' }>Meer informatie</Button>
        </div>
      </>
    </Dialog>
  )
}

export default LoginExplain;
